import IConsultaCartoesResponseDTO from '../entities/IConsultaCartoesResponseDTO'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IGetCartoes {
  execute(frotistaId: number): Promise<IConsultaCartoesResponseDTO>
}

export default class GetCatoes implements IGetCartoes {
  constructor(private readonly pagamentoRepository: IPagamentoRepository) {}
  public async execute(
    frotistaId: number,
  ): Promise<IConsultaCartoesResponseDTO> {
    return this.pagamentoRepository.getCartoes(frotistaId)
  }
}
